import { isTimeToBeDefined } from '@sportninja/common/ts-utils/date-utils'
import { Game, GameState } from '../types'

const getGameState = (game: Game): GameState => {
  const gameStarted = !!game.started_at
  const gameOver = !!game.ended_at
  const hasShootout = !!game.shootout
  const isGenericSport = game?.generic_sport_id !== null
  const statsRolledback = !!game.stats_rolledback
  const isGameTimeToBeDefined = isTimeToBeDefined(game.starts_at)

  const isOvertime = !!game?.current_period?.period_type?.is_overtime
  const isLive = gameStarted && !gameOver

  // Upcoming livestream
  const isUpcomingLivestream = game?.is_upcoming_livestream

  // Winner logic: game_status_id 2 = visiting forfeit (home wins),
  // game_status_id 3 = home forfeit (visiting wins)
  const homeTeamWon =
    gameOver &&
    (game.home_team_score > game.visiting_team_score ||
      game.game_status_id === 3)
  const visitingTeamWon =
    gameOver &&
    (game.home_team_score < game.visiting_team_score ||
      game.game_status_id === 2)

  const gameHasScores = gameStarted

  return {
    gameStarted,
    gameOver,
    hasShootout,
    isOvertime,
    isLive,
    isGenericSport,
    isUpcomingLivestream,
    statsRolledback,
    isGameTimeToBeDefined,
    homeTeamWon,
    visitingTeamWon,
    gameHasScores,
  }
}

export default getGameState
